import React, { useState } from 'react';
import Carat from './Carat';

const Journals = ({ journals, journalIds, updateJournals, checkedLength, id }) => {
  const [collapse, setCollapse] = useState(false);
  const [total, setTotal] = useState(checkedLength(Object.values(journals)));
  const [showMore, setShowMore] = useState(false);

  const handleChange = (journalId) => {
    let updatedJournals = { ...journals };
    updatedJournals[journalId].checked = !updatedJournals[journalId].checked;

    setTotal(updatedJournals[journalId].checked ? total + 1 : total - 1);
    
    updateJournals(updatedJournals);
  };

  const clearJournals = () => {
    let updatedJournals = { ...journals };
    journalIds.forEach((id) => {
      updatedJournals[id].checked = false;
    });
    setTotal(0);
    updateJournals(updatedJournals);
  };

  const renderJournals = () => {
    return journalIds.map((journalId) => {
      const el = journals[journalId];
      return (
        <div className={`checkbox-row ${el.checked ? 'checked' : ''}`} key={el.id + id}>
          <input id={el.id + id} type="checkbox" className="css-checkbox" checked={el.checked} onChange={() => handleChange(el.id)} />
          <label htmlFor={el.id + id}><span>{el.name}</span></label>
        </div>
      );
    });
  };

  const collapsedClass = () => {
    return collapse ? 'collapsed' : '';
  };

  return (
    <div className="row small-collapse">
      <div className="small-12 columns">
        <div className={`filter-header ${collapsedClass()}`} onClick={() => setCollapse(!collapse)}>
          <span>Journals </span>
          {<Carat collapse={collapse} setCollapse={setCollapse} />}
        </div>
        {!collapse && <div className="checkbox-container" style={showMore ? {} : { height: '220px' }}>
          {renderJournals()}
        </div>}
      </div>
    </div>
  );
};

export default Journals;